import {post, get} from '@/lib/axios';

const learning = {
  async get_total() {
    return get(`/learning/total`);
  },
  async get_total_business_plus() {
      return get(`/learning_business_plus/total`);
  },
  async get_organizations({sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, search}) {
    return get(`/learning/organizations`, {sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, search});
  },
  async get_companies({sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, country, period_start, period_finish, search}, page = 1, page_size = 10) {
    return get(`/learning/companies`, {sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, country, period_start, period_finish, search, page, page_size});
  },
  async get_users({sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, country, period_start, period_finish, search}, page = 1, page_size = 10) {
    return get(`/learning/users`, {sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, country, period_start, period_finish, search, page, page_size});
  },
  async get_courses({sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, user_id, status, search}) {
    return get(`/learning/courses`, {sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, user_id, status, search});
  },
  async get_courses_summary({sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, user_id, country, search}, page = 1, page_size = 10, business_plus = 0) {
    return get(`/learning/courses/summary`, {sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, user_id, country, search, page, page_size, business_plus});
  },
  async get_courses_business_plus_summary({sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, user_id, country, search}, page = 1, page_size = 10, business_plus = 1) {
    return get(`/learning/courses_business_plus/summary`, {sort_name, sort_direction, user_type, company_group, company, region, city, department, course, course_required, role, specialization, period_start, period_finish, user_id, country, search, page, page_size, business_plus});
  },
  async org_export(filter) {
    return get(`/file/statisticOrganizations`, filter);
  },
  async companies_export(filter) {
    return get(`/file/statisticCompanies`, filter);
  },
  async users_export(filter) {
    return get(`/file/statisticUsers`, filter);
  },
  async courses_export(filter) {
    return get(`/file/statisticCourses`, filter);
  },
  async courses_summary_export(filter) {
    return get('/file/statisticCoursesSummary', filter)
  },
  async courses_business_plus_summary_export(filter) {
    return get('/file/statisticCoursesBusinessPlusSummary', filter)
  },
  async  user_learning_detail(user_id, course_id ) {
    return get(`/learning/user/detail`, {user_id, course_id});
  },
  async course_learning_detail(course_id, period_start, perios_finish) {
    return get(`/learning/course/detail`, {course_id, period_start, perios_finish});
  },
  async learning_users_count(filter) {
    return get(`/learning/users/filteredCount`, filter);
  },
  async learning_courses_count(filter) {
    return get(`/learning/courses/filteredCount`, filter);
  },
};

export {learning as default};
